import React, { Component } from 'react';
import { graphql } from 'gatsby';
import Layout from 'components/layout';
import { NavBar, PopupRedirect } from 'components';
import 'styles/main.scss';
import HomePage from 'views/home';
import { pages } from 'config/pages';

class Home extends Component {
  render() {
    const page = pages.default;
    const { navColors } = page;

    return (
      <Layout page={page}>
        <NavBar
          color={navColors}
          banner={{
            key: 'newsletter',
            newsletter: true,
          }}
        />
        <PopupRedirect homepage />
        <HomePage />
      </Layout>
    );
  }
}

export const pageQuery = graphql`
  fragment markdownFields on MarkdownRemarkConnection {
    edges {
      node {
        excerpt(pruneLength: 400)
        id
        fields {
          slug
        }
        frontmatter {
          title
          order
          content {
            body
          }
          job
          photo
          cover
          lead
          templateKey
          settings {
            date(formatString: "MMMM DD, YYYY")
            slug
            type
            category
          }
          contributor
        }
      }
    }
  }

  fragment boxMarkdownFields on MarkdownRemarkConnection {
    edges {
      node {
        frontmatter {
          box {
            content {
              title
              tags
              clientLogo
              coverImage
            }
            settings {
              tileColor
              textColor
              link
            }
            type
          }
        }
      }
    }
  }
`;

export default Home;
